import type { FormDefinition2 } from '@gov-nx/core/service';
import { useAuthorizedLabel, useLocale } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { Button, Dialog } from '@gov-nx/ui/web';
import { SouhlasCheckbox } from '../../Autorizace/SouhlasCheckbox';
import { GovFormWeb } from '@gov-design-system-ce/react-form';

interface RecallConsentPromptProps {
	isOpen: boolean;
	isConsentRecalling: boolean;
	isLowAuthorization: boolean;
	isAuthorizationEnforced: boolean;
	formDefinition: FormDefinition2<Record<never, never>, unknown>;
	onSubmit: () => void;
	onClose: () => void;
}

const FORM_ID = 'ZR10_RECALL_FORM';

export const RecallConsentPrompt = ({
	isOpen,
	isConsentRecalling,
	isLowAuthorization = false,
	isAuthorizationEnforced = false,
	formDefinition,
	onSubmit,
	onClose,
}: RecallConsentPromptProps) => {
	const { t } = useLocale(PageCode['sprava-souhlasu']);
	const authLabel = useAuthorizedLabel();
	return (
		<Dialog
			isOpen={isOpen}
			onClose={onClose}
			title={<h3>{t('modal.pole.odvolani-souhlasu')}</h3>}
			footer={
				<Button
					form={FORM_ID}
					nativeType="submit"
					aria-label={authLabel(
						t('tlacitko.akce.odvolat'),
						isAuthorizationEnforced
					)}
					color="primary"
					type="solid"
					size="m"
					isLoading={isConsentRecalling}
					isDisabled={isConsentRecalling}>
					{authLabel(t('tlacitko.akce.odvolat'), isAuthorizationEnforced)}
				</Button>
			}>
			<GovFormWeb
				id={FORM_ID}
				onSubmit={onSubmit}
				formDefinition={formDefinition}>
				{t('modal.pole.potvrzeni-odvolani')}
				<SouhlasCheckbox
					show={isLowAuthorization}
					disabled={isConsentRecalling}
				/>
			</GovFormWeb>
		</Dialog>
	);
};
